<template>
<v-container fluid>
    <v-layout justify-center align-center>
        <v-flex md10>
          <Datatable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
        </v-flex>
    </v-layout>
    <GeneralDialog v-if="get_dialogMain.dialog" :form="formulario" action="familias.create-update"/>
</v-container>
</template>

<script>
// import router from '@/router'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import tableMain from '@/components/dataTableMain'
import GeneralDialog from '@/components/dialog/GeneralDialog'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'toCreateFam', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: []
      },
      footer: {
        paging: true
      }
    },
    formulario: {
      fields: [
        {
          field: 'text',
          type: 'text',
          name: 'Nombre',
          nameid: 'nombre',
          cols: 6,
          offset: 0
        },
        {
          field: 'selectDataServer',
          name: 'Empresa',
          nameid: 'empresa_id',
          url: '/empresas',
          cols: 6,
          offset: 0
        }
      ]
    }
  }),
  components: {
    Datatable: tableMain,
    GeneralDialog
  },
  mounted () {
    this.getDataUrl('inventario.familias.list')
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    toCreateFam () {
      this.SHOW_DIALOG_MAIN({ type: 'create', withWindows: 800, title: 'Agregar Familia' })
    },
    refreshData () {
      this.table.header.loading = true
      this.getDataUrl('inventario.familias.list')
    },
    tableAction (item) {
      this[item.action](item)
    },

    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('inventario.familias.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
